/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// global elements
import Structure from 'components/shared/structure/structure_container';
// unique elements
import Frame from 'components/frames/frame_container';
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import InsticatorLogo from 'components/shared/logo/insticator/insticator_container';
import PartnerLogo from 'components/shared/logo/partner/partner_container';
// utils
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
import { url } from 'utils/urls';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/outofcontent/outofcontent_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ NO CONTENT SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class OutOfContentScreen extends Component {
    componentWillMount() {
        this.props.setTotalFrameCount(this.props.contentId, 1);
    }
    isActiveContent(props = this.props) {
        return props.currentContentStatus['status'] === 'active';
    }
    partnerMessage = () => (
        <div className={`partnermessage`}>
            <PartnerLogo contentId={null} />
        </div>
    )
    fallbackMessage = () => (
        <div className={`fallbackmessage`}>
            <div className={`graphic ooc`} />
            <Title>{`Stay Connected`}</Title>
            <BodyCopy>
                <p>There is no more content at this time – stay tuned for daily updates!</p>
            </BodyCopy>
        </div>
    )
    render() {
        if (!this.isActiveContent()) { return null; }
        const logoSrc = this.props.settings.embedSettings.elements.partnerLogo.src;
        return(
            <div className={`${sheet.classes.uniquecontent} uniquecontent ${this.props.currentContentStatus['type']} inview-${this.props.embedStatus.inView}`}>
                <div className={`uniquescreen`}>
                    {logoSrc != null && logoSrc != "" && logoSrc != undefined ? this.partnerMessage() : this.fallbackMessage()}
                </div>
                <div className={`footer`}>
                    <InsticatorLogo contentId={this.props.contentId} poweredBy={true} />
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default OutOfContentScreen;
